import React, {useState } from "react";
import { OverlayTrigger, Tab, Tabs } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useParams } from "react-router-dom";
import TaskIcon from "assets/svgs/task_list";
import TabTaskList from "./TabTaskList";
import StickyTaskList from "./StickyTaskList";
import { useTaskListData } from "./store";
import { fourPlaceHolder } from "modules/utilities/utility";

function TaskList() {
  const [show, setShow] = useState(false);
  const [key, setKey] = useState('taskList');
  const {taskData,taskLoading, fetchTaskListData} = useTaskListData();
  const {id} = useParams();
  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
    fetchTaskListData(id);
  };

  return (
    <>
      <div variant="primary" className="mt-n1">
        <div className="d-flex ">
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
              >
                <div className="fw-bold">Task List</div>
              </Tooltip>
            }
          >
            <div
              className="d-flex text-primary cursor-pointer"
              onClick={handleShow}
            >
              <TaskIcon width={40} height={38} />
            </div>
          </OverlayTrigger>
        </div>
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        style={{ width: "49%" }}
        placement="end"
      
      >
        <Offcanvas.Header closeButton className="bg-light" style={{zIndex:"999"}}>
          <Offcanvas.Title className="mb-n2">
            <div>
              <div className="">
                <span className="text-primary fw-bold">Task List</span>
              </div>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="mt-n3">
         {taskLoading?fourPlaceHolder(): <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => setKey(k)}
            variant="pills"
            className="position-sticky top-0 bg-white"
          >
            <Tab
              eventKey="taskList"
              title="Task List"
              className="border border-x"
            >
                <TabTaskList  taskData={taskData}/>
            </Tab>
            <Tab
              eventKey="stickyList"
              title="Sticky List"
              className="border-bottom border "
            >
              <StickyTaskList taskData={taskData} />
            </Tab>
          </Tabs>}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default TaskList;